var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"student-schedule"},[_c('div',{staticClass:"student-schedule__main"},[_c('sidebar-switcher',{staticClass:"student-schedule__main__sidebar"}),_c('top-schedule')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }